import { Field } from 'formik';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type CheckboxProps = {
  children: ReactNode;
  name: string;
  labelClassName?: string;
};
const Checkbox = ({ children, labelClassName, name }: CheckboxProps) => {
  const labelTwClassName = 'body mb-2';

  return (
    <label className={twMerge(labelTwClassName, labelClassName)}>
      <Field className="h-5 w-5" name="privacy" type="checkbox" />
      <span className="ml-2">{children}</span>
    </label>
  );
};

export default Checkbox;
